export function saveHomepageBanners(state){
  return {
    type: 'SAVE_HOMEPAGE_BANNERS',
    payload: state
  }
}